import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from 'src/app/modules/shared/services/auth.service';
import { ScrollControlService } from 'src/app/modules/shared/services/scroll-control.service';
import { SidenavService } from 'src/app/modules/shared/services/sidenav.service';
import { LanguageService } from 'src/app/modules/shared/services/language.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/modules/shared/services/data.service';
import { EstimationState } from 'src/app/models/EstimationState';

@Component({
  standalone: false,
  selector: 'app-result-container',
  templateUrl: './result-container.component.html',
  styleUrls: ['./result-container.component.css']
})
export class ResultContainerComponent implements OnInit {

  isOpen: boolean = false;
  userName: any;
  shouldPinSidenav: boolean = false;
  variables: any = {};
  estimateName: string = '';
  estimationState: EstimationState = EstimationState.COMPLETE;

  @Input() estId?: string;


  constructor(private sidenavService: SidenavService,
    public authService: AuthService,
    private scrollService: ScrollControlService,
    private router: Router,
    private route: ActivatedRoute,
    private dataService: DataService,
    private languageService: LanguageService) { }


  public estimationStateEnum = EstimationState;


  ngOnInit() {
    this.scrollService.setScroll(true);

    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });

    const routeEstimateId = this.route.snapshot.paramMap.get('id') || undefined;
    this.estId = this.estId || routeEstimateId;

    // Ensure deep links can load estimate data in child components.
    if (this.estId) {
      this.dataService.setEstimate(this.estId);
    }
  }

  onSidenavToggle() {
    this.isOpen = !this.isOpen;
    this.sidenavService.sideNavState$.next(this.isOpen);
  }

  onCheckboxChange(event: any) {
    this.shouldPinSidenav = event;
    this.sidenavService.shouldPinSidenavState.next(this.shouldPinSidenav);
  }

  // Handle estimate name changes from result component
  onEstimateNameChange(name: string): void {
    this.estimateName = name;
  }

  // Handle estimate state changes from result component
  onEstimateStateDetect(state: EstimationState): void {
    this.estimationState = state;
  }

  canCheckImputationAndDeviation(): boolean {
    return this.estimationState === EstimationState.APPROVED || this.estimationState === EstimationState.CLOSED;
  }

  goToDashboard() {
    const source = this.dataService.getEstimativaNavigationContext() as { origin?: string } | null;
    this.dataService.clearEstimativaNavigationContext();
    if (source?.origin === 'combinedResultPage') {
      this.router.navigate(['/projecto']);
    } else if (source?.origin === 'resultPage') {
      this.router.navigate(['/estimativa/resultado']);
    } else {
      this.router.navigate(['/dashboard']);
    }
  }
}

